module.exports = __webpack_public_path__ + "static/img/pic2@2x.0ea8d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/pic2@2x.png
// module id = CC/l
// module chunks = 0